import { Link, createFileRoute } from '@tanstack/react-router';
import { ArrowLeft, CircleHelp } from 'lucide-react';

import { Card } from '@/components/Card';
import { PageHeader } from '@/components/PageHeader';
import { TourList } from '@/components/tour/TourList';
import { QUICK_HELP, TOUR_UI } from '@/lib/i18n/tours';

/**
 * Recorridos guiados. Antes era una guía de texto; ahora cada recorrido te
 * lleva por las pantallas de verdad. Debajo queda una ayuda mínima para lo
 * que no se enseña con un recorrido.
 */
export const Route = createFileRoute('/_app/settings/guide')({ component: ToursPage });

function ToursPage() {
  return (
    <>
      <PageHeader
        title={TOUR_UI.pageTitle}
        subtitle={TOUR_UI.pageSubtitle}
        action={
          <Link
            to="/settings"
            aria-label={TOUR_UI.back}
            className="flex size-11 items-center justify-center rounded-xl border border-line text-ink-muted hover:bg-surface-raised"
          >
            <ArrowLeft className="size-5" aria-hidden="true" />
          </Link>
        }
      />
      <div className="flex flex-col gap-6">
        <TourList />
        <Card
          title={
            <span className="flex items-center gap-2">
              <CircleHelp className="size-5 shrink-0 text-brand" aria-hidden="true" />
              {QUICK_HELP.title}
            </span>
          }
        >
          <div className="flex flex-col divide-y divide-line">
            {QUICK_HELP.items.map((item) => (
              <details key={item.q} className="group py-1">
                <summary className="flex min-h-11 items-center text-sm font-medium text-ink">
                  {item.q}
                </summary>
                <p className="pb-3 text-sm leading-relaxed text-ink-muted">{item.a}</p>
              </details>
            ))}
          </div>
        </Card>
      </div>
    </>
  );
}
